export type SelectorEntry = {
  selector: string
  label: string
  category: "tree" | "decisions" | "modals" | "navigation" | "search" | "plans" | "tree-node"
  description?: string
  /** True if this selector requires a tree node mapping name (e.g. {{nodeName}}). */
  templated?: boolean
}

export const SELECTOR_CATALOG: SelectorEntry[] = [
  // Navigation / decision ribbon
  {
    selector: "#makeDecision",
    label: "Make Decision button",
    category: "decisions",
  },
  {
    selector: "#submitDecisionButton",
    label: "Submit Decision button",
    category: "decisions",
  },
  {
    selector: "#decisionSubmitButton",
    label: "Decision submit (alt)",
    category: "decisions",
  },
  {
    selector: "#decisionPlanButtons",
    label: "Decision/Plan buttons row",
    category: "decisions",
  },
  {
    selector: "#decisionsMenuButton",
    label: "Decisions menu button",
    category: "navigation",
  },
  {
    selector: "#plansMenuButton",
    label: "Plans menu button",
    category: "navigation",
  },
  {
    selector: "#createPlan",
    label: "Create Plan button",
    category: "plans",
  },
  {
    selector: "#planListContainer",
    label: "Plan list container",
    category: "plans",
  },
  {
    selector: "#addConnectionsButton",
    label: "Add Connections button",
    category: "plans",
  },
  {
    selector: "#connectionsSubmit",
    label: "Connections submit",
    category: "plans",
  },

  // Modals
  {
    selector: "#aboutSimulationButton",
    label: "About Simulation button",
    category: "modals",
  },
  {
    selector: "#aboutSimulationModal",
    label: "About Simulation modal",
    category: "modals",
  },
  {
    selector: "#helpButton",
    label: "Help button",
    category: "modals",
  },
  {
    selector: "#helpModal",
    label: "Help modal",
    category: "modals",
  },

  // Tree / search
  {
    selector: "#tree-container",
    label: "Tree container",
    category: "tree",
  },
  {
    selector: "#treeAndSearchContainer",
    label: "Tree + search container",
    category: "tree",
  },
  {
    selector: "#treeSearchInput",
    label: "Tree search input",
    category: "search",
  },
  {
    selector: "#searchForInformation",
    label: "Search for Information button",
    category: "search",
  },
  {
    selector: "#clearTreeSearchButton",
    label: "Clear tree search button",
    category: "search",
    description:
      "Appears after a search has been performed; used by clearSearch action.",
  },

  // Tree node references (require a tree mapping name)
  {
    selector: "#tree-item-{{node}}",
    label: "Tree item (node)",
    category: "tree-node",
    description:
      "References a tree node by mapping name. The runtime substitutes `{{node}}` with the resolved node ID.",
    templated: true,
  },
  {
    selector: "#tree-item-{{node}}-container",
    label: "Tree item container (node)",
    category: "tree-node",
    description:
      "References the container of a tree node. Use for hover targets and group highlights.",
    templated: true,
  },
]

export const SELECTOR_CATEGORIES: Record<SelectorEntry["category"], string> = {
  tree: "Tree",
  decisions: "Decisions",
  modals: "Modals",
  navigation: "Navigation",
  search: "Search",
  plans: "Plans",
  "tree-node": "Tree node references",
}

export const isKnownStableSelector = (selector: string): boolean => {
  if (SELECTOR_CATALOG.some((e) => e.selector === selector)) return true
  // Tree node templated selectors: any string matching #tree-item-...{-container}? counts as known
  return /^#tree-item-[^\s]+(-container)?$/.test(selector)
}
